import React from 'react';

import CustomerGiftCard from './CustomerGiftCard';

const { UI, Customer } = Mobi2Go;

let modal;

Mobi2Go.onReady(() => {
    modal = UI.ExternalModal.create(
        'customer-gift-card',
        <CustomerGiftCard
            closeModal={() => {
                modal.close();
            }}
        />,
        {
            'data-view': 'customer-gift-card',
            className: 'm2g-customer-gift-card',
        }
    );

    modal.mount();
});

const openGiftCardForm = openPreviousModal => {
    if (!Customer.isLoggedIn()) {
        return;
    }

    if (Customer.getVerifiedAt()) {
        if (openPreviousModal) {
            modal.setOnBeforeCloseHook(() => {
                openPreviousModal();
                return true;
            });
        }
        modal.open();
    } else {
        UI.trigger('showCustomerVerification', openGiftCardForm);
    }
};

export default openGiftCardForm;
